import React, { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import Img from 'gatsby-image';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Scrollbar, Navigation } from 'swiper';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

import ProductStatus from './ProductStatus';

import { IProductPhotosProps } from './Types';
import './ProductPhotos.scss';
import PhotoModal from '../Modal/PhotoModal';

SwiperCore.use([Pagination, Scrollbar, Navigation]);

const ProductPhotos: React.FC<IProductPhotosProps> = ({ images, productStatus }): JSX.Element => {
  const [currentPhoto, changePhoto] = useState<number>(0);
  const [showModal, setShowModal] = useState<boolean>(false);
  const breakpoints = useBreakpoint();
  const handleShowModal = useCallback(() => {
    setShowModal(prev => !prev);
    document.body.classList.toggle('fixed');
  }, [showModal]);

  return breakpoints.laptops ? (
    <>
      <div className="product-photos">
        <div className="product-photos-feed-wrapper">
          <div className="product-photos-feed">
            {images.map(({ childImageSharp: { fluid }, id }, idx) => (
              <div
                key={id}
                className={`product-photos-feed-item ${id === images[currentPhoto].id && 'current-item'}`}
                onClick={() => {
                  changePhoto(idx);
                }}
              >
                <Img fluid={fluid} />
              </div>
            ))}
          </div>
        </div>
        <div onClick={handleShowModal} className="product-photos-feed-main">
          <Img fluid={images[currentPhoto].childImageSharp.fluid} imgStyle={{ objectFit: 'cover' }} />
        </div>
      </div>
      {showModal &&
        createPortal(
          <PhotoModal close={handleShowModal}>
            <img src={images[currentPhoto].childImageSharp.fluid.src} alt="modal" />
          </PhotoModal>,
          document.body
        )}
    </>
  ) : (
    <div className="product-photos">
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        direction="horizontal"
        centeredSlides={false}
        className="swiper"
        scrollbar={{
          el: '.swiper-scrollbar',
          draggable: true,
          dragSize: 30,
        }}
      >
        {images.map(({ childImageSharp: { fluid }, id }, idx) => (
          <SwiperSlide>
            <div
              key={id}
              className="product-photos-feed-item"
              onClick={() => {
                changePhoto(idx);
              }}
            >
              {idx === 0 && (
                <div className="product-photos-feed-item-status">
                  <ProductStatus status={productStatus} />
                </div>
              )}
              <Img fluid={fluid} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      {images.length > 1 && (
        <div className="swiper-scrollbar">
          <div className="swiper-scrollbar-drag" />
        </div>
      )}
    </div>
  );
};

export default ProductPhotos;
